export default "__VITE_ASSET__DXcNPUX1__"